Subboard = function(data) {
    var self = this;

    var props = [
        {name: 'name'},
        {name: 'description'},
        {name: 'slug'},
        {name: 'icon'},
        {name: 'color'},
        {name: 'salespage'},
        {name: 'permissions', data_type: 'array'},
        {name: 'subboards', data_type: 'array'},
    ];

    self.activeDataRelations = [
        {type: 'belongsTo', storeTarget: 'boards', key: 'mainboard_id', storage: 'board'},
        {type: 'hasMany', storeTarget: 'topics', key: 'board_id', storage: 'topics'},
    ];

    ActiveData.call( self, data); //javascript 'classes' workaround
    self.activeDataInit(self, data, props); //setup active data
};